export const ledapAppStoreUrl = 'https://apps.apple.com/app/bookli/id1551810263'
export const ledapGooglePlayStoreUrl = 'https://play.google.com/store/apps/details?id=dk.bookli.app'